<!-- 询单信息卡片 -->
<template>
    <div class="container" v-loading="loading" :element-loading-text="loadingText">
        <div class="card" v-for="(item, index) in datas" :key="index">
            <el-card class="el-card" shadow="always">
                <div class="lineBox">
                    <img class="imgs" src="#" alt="">
                    <div class="lineBoxText">
                        <p class="lineBoxTextP1">{{ item.createName }}</p>
                        <div class="lineBoxTextDiv1">{{ $store.state.orderFlowDirection === 1 ? '客户' : '您' }}于{{ item.createTime | dateFormatHms }}提出一个
                            <el-tag effect="dark">{{ resourceType.find(n => n.code == allDatas.state).name1 }}</el-tag>
                            询价 <span class="lineBoxTextSpan1">行程：{{ item.planId }}</span>
                            <span v-if="$store.state.orderFlowDirection === 1">
                                <el-button style="margin-left: 0.1rem;" @click="send(1)" size="mini" type="primary">发
                                    送</el-button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="infoDetail">
                    <div class="infoDetailL">
                        <div class="infoDetailLine">
                            <p class="infoDetailP1">城市：</p>
                            <p>{{ item.jsonObject.cityName }}</p>
                        </div>
                        <div class="infoDetailLine">
                            <p class="infoDetailP1">日期：</p>
                            <p>{{ item.jsonObject.startDate }} 至 {{ item.jsonObject.endDate }}</p>
                        </div>
                        <div class="infoDetailLine">
                            <p class="infoDetailP1">需求：</p>
                            <div>
                                <div style="display: flex;align-items: center;"
                                    v-for="(item1, index1) in item.jsonObject.orderProjectDetails" :key="index1">
                                    <p style="margin-right: 0.1rem;">{{ item1.productName }}</p>
                                    <p> 数量：<span class="infoDetailP1">{{ item1.number }}</span> 币种：<span
                                            class="infoDetailP1">{{
                                                item1.currency
                                            }}</span></p>
                                </div>
                            </div>
                        </div>
                        <div class="infoDetailLine">
                            <p class="infoDetailP1">备注：</p>
                            <p>{{ item.jsonObject.remarks }}</p>
                        </div>
                    </div>
                    <div class="infoDetailR">
                        <el-divider class="infoDetailRLine" direction="vertical"></el-divider>
                        <div class="infoDetailRBox">
<!--                            <p class="infoDetailRBoxP1" v-if="item.stockLock === 0 || !item.stockLock || !item.newNumber">请您再耐心等待一下哦</p>-->
<!--                            <i v-else @click="launchClick(item, index)" :class="item.isShow ? 'up' : 'down'"-->
<!--                                class="icon el-icon-arrow-down"></i>-->
                            <p class="infoDetailRBoxP1" v-if="!item.newNumber">请您再耐心等待一下哦</p>
                            <i v-else @click="launchClick(item, index)" :class="item.isShow ? 'up' : 'down'"
                               class="icon el-icon-arrow-down"></i>
                        </div>
                    </div>
                </div>
            </el-card>
            <el-collapse-transition>
                <div v-show="item.isShow" style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;">
                    <div class="detailListBox">
                        <div class="detailBox">
                            <inquiryDetail @cancelClick="cancelClick" @packagingData="packagingData" :checked="checked"
                                @checkDatas="checkDatas" ref="inquiryDetail" :requestData="{
                                    inquiryId: item.inquiryId,
                                    state: item.resourceType,
                                    stockType: 3,
                                }"></inquiryDetail>
<!--                            orderFlowDirection: $store.state.orderFlowDirection,-->
                        </div>
                        <div @click="item.isShow = false" style="display: flex; justify-content: flex-end;">
                            <i class="el-icon-arrow-up icon"></i>
                        </div>
                    </div>
                </div>
            </el-collapse-transition>

        </div>
        <div class="after">
            <el-button v-if="$store.state.orderFlowDirection == 0 && datas.some(item => item.isShow === true)"
                type="primary" @click="send(2)">创建订单</el-button>
        </div>
        <Pay :order-main-id="allDatas.orderMainId" @payUpload="$emit('update')" v-if="JSON.stringify(PayDatas) !== '{}'" ref="Pay"
            :dataMap="{ totalPrice: PayDatas.payMoney }" :payMoney="Number(PayDatas.payMoney)"
            :orderChildrenIds="PayDatas.orderChildrenIds"></Pay>
    </div>
</template>

<script>
import inquiryDetail from './inquiryDetail.vue'
import Api from '../../../../../../components/Api'
import { resourceType, getGroup } from '@/assets/utils/unit'
import OrderApi from '../../../../../../components/Api/order'
import Pay from '@/components/ThirdPay/Pay'
export default {
    props: {
        //这条数据的全部数据
        allDatas: {
            type: Object,
            default: {}
        },
    },
    components: {
        inquiryDetail,
        Pay
    },
    data() {
        return {
            loadingText: '拼命加载中',
            PayDatas: {},
            resourceType,
            loading: false,
            datas: [],//渲染的数据
            checked: [],//多选的数据
            current: 0,//展开的下标
        }
    },
    computed: {},
    watch: {},
    methods: {
        //展开
        launchClick(item, index) {
            this.current = index
            if (!item.isShow) {
                this.$refs.inquiryDetail[index].projectInquiryStockList()
            }
            item.isShow = !item.isShow
        },
        //多选的数据
        checkDatas(val) {
            if (val.mergerPurchase) { //如果他有值，说明它是打包购买
                this.$refs.inquiryDetail[this.current].processPackagedData(val.mergerPurchase)
            } else {
                if (this.checked.findIndex(n => n.stockId === val.stockId) === -1) {
                    this.checked.push(val)
                } else {
                    this.checked = this.checked.filter(n => n.stockId !== val.stockId)
                }
            }
            console.log('看看选中的数据', this.checked);
        },
        //打包数据的处理
        packagingData(arr) {
            arr.forEach(item => {
                if (this.checked.findIndex(n => n.stockId === item.stockId) === -1) {
                    this.checked.push(item)
                } else {
                    this.checked = this.checked.filter(n => n.stockId !== item.stockId)
                }
            })
        },
        //询单列表数据
        projectInquiryList() {
            this.loading = true
            let obj = {
                page: 1,
                q: {
                    id: this.allDatas.orderInquiryId ? this.allDatas.orderInquiryId : null,
                    planId: null,
                    orderChildrenId: this.allDatas.orderInquiryOrderChildrenId ? this.allDatas.orderInquiryOrderChildrenId : this.allDatas.orderChildrenId,
                    orderFlowDirection: this.$store.state.orderFlowDirection,
                    resourceTypes: [this.allDatas.state]
                },
                size: 100
            }
            new Api('inquiry').projectInquiryList(obj).then(res => {
                if (res.status == 200) {
                    this.datas = res.data.records
                    this.datas.forEach(item => {
                        this.$set(item, 'isShow', false)
                    })
                    this.loading = false
                } else {
                    this.$message({
                        type: 'warning',
                        message: res.statusText
                    });
                    this.loading = false
                }
            })
        },
        //取消
        cancelClick(val) {
            this.send(0, [val])
        },
        //发送和取消发送
        send(type, arrs) {
            const map = {
                0: {
                    tip: "取消发送",
                    eve: 'orderCancelSending',
                    tip1: '取消成功',
                    loadingText: '取消中...'
                },
                1: {
                    tip: "发送",
                    eve: 'orderLevelPriceAddition',
                    tip1: '发送成功',
                    loadingText: '发送中...'
                },
                2: {
                    tip: "创建订单",
                    eve: 'createOrderByInquiry',
                    tip1: '创建成功',
                    loadingText: '创建中...'
                }
            }

            let sendArr = type == 0 ? arrs : JSON.parse(JSON.stringify(this.checked))
            if (sendArr.length > 0) {
                this.$confirm(`您确定${map[type].tip}吗, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true
                    this.loadingText = map[type].loadingText
                    let obj
                    let arr = []
                    if (type == 2) {
                        obj = {
                            "detailRequestList": [],
                            "orderChildrenId": this.allDatas.orderChildrenId
                        }
                        let sendArrGroup = getGroup(sendArr, 'inquiryId')
                        for (const keys in sendArrGroup) {
                            let choiceStockIds = []
                            let priceList = []
                            sendArrGroup[keys].forEach(item => {
                                choiceStockIds.push(item.stockId)
                                for (const keys1 in item.priceList) {
                                    priceList = item.priceList[keys1]
                                }
                                item.priceList = priceList
                            })
                            choiceStockIds = [...new Set(choiceStockIds)];
                            let detailRequestItem = {
                                "choiceStockIds": choiceStockIds,
                                "choiceStockListResultList": sendArrGroup[keys],
                                "orderInquiryId": keys
                            }
                            obj.detailRequestList.push(detailRequestItem)
                        }
                    } else {
                        obj = JSON.parse(JSON.stringify(this.$refs.inquiryDetail[this.current].others))
                        sendArr.forEach(item => {
                            const findData = obj.orderProfitInquiryStockList.find(n => n.stockId === item.stockId)
                            if (findData) {
                                arr.push(findData)
                                for (const keys in item.priceList) {
                                    item.priceList[keys].forEach(item1 => {
                                        if (item1.stockPriceId) {
                                            let findData1 = findData.orderProfitInquiryStockPriceDetailList.find(n => n.stockPriceId === item1.stockPriceId)
                                            if (findData1) {
                                                this.$set(findData1, 'salePrice', item1.toCPrice)
                                            }
                                        }
                                    })
                                }
                            }
                        })
                        obj.orderProfitInquiryStockList = arr
                    }
                    new OrderApi('order')[map[type].eve](obj).then(res => {
                        if (res.status === 200) {
                            this.checked = []
                            if (res.data && type == 2) {
                                this.PayDatas = res.data
                                setTimeout(() => {
                                    this.$refs.Pay.init();
                                    this.loading = false
                                    this.$message({
                                        type: 'success',
                                        message: map[type].tip1
                                    });
                                }, 2000);
                            } else {
                                this.$refs.inquiryDetail[this.current].projectInquiryStockList(arr)
                            }
                        } else {
                            this.$message.error({ message: res.statusText })
                            this.loading = false
                        }
                    })
                })
            } else {
                this.$message({
                    message: '请您至少勾选一条数据！',
                    type: 'warning'
                });
            }
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
.container {
    min-height: 30vh;
    max-height: 80vh;
    overflow-y: scroll;
    position: relative;
}

.container::-webkit-scrollbar {
    width: 0.2em;
}

.container::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.2em;
}

.card {
    border-radius: 15px 15px 0 0 !important;
    border-bottom: 2px solid #DE4D20;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    margin-bottom: 0.15rem;
}

.el-card {
    position: sticky;
    top: 0;
    z-index: 99;
}

.icon {
    color: #DE4D20;
    font-size: 0.4rem;
    cursor: pointer;
}

.up {
    transform: rotate(-180deg);
    transition: all 0.1s ease;
}

.down {
    transition: all 0.1s ease;
}

.lineBox {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .imgs {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        margin-right: 0.1rem;
    }

    .lineBoxText {
        .lineBoxTextP1 {
            margin-bottom: 0.08rem;
            color: #DE4D20;
        }

        .lineBoxTextDiv1 {
            color: #DE4D20;
            font-weight: bold;

            .lineBoxTextSpan1 {
                margin-left: 0.15rem;
            }
        }
    }
}

.infoDetail {
    background: #FAFBF9;
    padding: 0.1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    .infoDetailL {
        .infoDetailLine {
            display: flex;
            // align-items: center;
            margin-bottom: 0.1rem;

            .infoDetailP1 {
                color: #DE4D20;
            }

        }
    }

    .infoDetailR {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;

        .infoDetailRLine {
            height: 90%;
        }

        .infoDetailRBox {
            width: 1.7rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .infoDetailRBoxP1 {
                color: #DE4D20;
                text-align: center;
            }
        }
    }

}

.detailListBox {
    border: 1px solid #DE4D20;

    .detailBox {
        margin: 0.15rem 0;
        padding: 0 0.1rem;
    }
}

.after {
    text-align: center;
}
</style>